import './index.less'
import { footerPhoneSubs, shopCR } from "@utils/fetch.js"

export default class PhotovolaticSaveElectric {
  constructor({ el, }) {
    this.DOM = document.querySelector(el)
    if (this.DOM) {
      this.init()
      this.observe()
    }
  }
  init() {
    // 比率计算
    this.initSaveElecticRate()

    // 邮箱订阅
    try {
      document.querySelector('[data-photovolatic-subscribe]') && this.initEmailSubscribe()
    } catch (error) {
      console.log(error)
    }
  }
  // 比率计算
  initSaveElecticRate() {
    const withStorage = document.querySelector('[data-with-storage]')
    const withNumber = withStorage.dataset.number
    const withoutStorage = document.querySelector('[data-without-storage]')
    const withoutNumber = withoutStorage.dataset.number

    const rate = (parseInt(withoutNumber) / parseInt(withNumber)) * 100 + '%'
    this.DOM.style.setProperty('--photovolatic-storage-rate', rate);
  }
  // 邮箱订阅
  initEmailSubscribe() {
    try {
      document.querySelector('[data-photovolatic-subscribe]').onclick = (e) => {

        const emailInput = document.querySelector('[data-photovolatic-email-input]');
  
        if ($('.J-subscribe-declaration-checkbox').length > 0) {
          let isChecked = $('.J-subscribe-declaration-checkbox')[0].checked;
  
          if (!isChecked) {
            $('.J-subscribe-declaration-span').addClass('wobble-hor-bottom');
            setTimeout(() => {
              $('.J-subscribe-declaration-span').removeClass('wobble-hor-bottom');
            }, 1100);
            return;
          }
        }
  
        const email = emailInput.value.trim() || '';
  
        if (!email) {
          pushMessage(
            shopCR === 'DE'
              ? 'Geben sie ihre E-Mailadresse ein'
              : 'Enter Your Email Address',
            'warning');
          return false;
        }
  
        const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!emailReg.test(email)) {
          pushMessage(
            shopCR === 'DE'
              ? 'Ungültige E-Mail-Adresse'
              : 'Invalid Email Address',
          'warning');
          return false;
        }
  
        footerPhoneSubs({ email, tags: "DIY SG" }).then((res) => {
          if (res.code === 200) {
            pushSuccessMessage(
              shopCR === 'DE'
                ? 'Erfolgreich! Du hast die E-Mail-Benachrichtigungen von Jackery abonniert.'
                : "Success! You're all set to receive Jackery text messages"
            )
            emailInput.value = '';
          } else {
            let error_t = '';
            if (res.code === 70002) {
              error_t = 'Invalid Phone Number';
            } else {
              error_t = 'Server Error';
            }
            pushErrorMessage(error_t);
          }
        });

        // 数据埋码
        const { sectionTitle, buttonText, } = e.target.dataset
        this.GAEvent({
          position: sectionTitle,
          button_name: buttonText,
        })
      };
  
      if ($('.J-subscribe-declaration-span').length > 0) {
        let termsService = $('.J-subscribe-declaration-span').data('terms_service');
        let termsServiceUrl = $('.J-subscribe-declaration-span').data('terms_service_url');
        let privacyPolicy = $('.J-subscribe-declaration-span').data('privacy_policy');
        let privacyPolicyUrl = $('.J-subscribe-declaration-span').data('privacy_policy_url');
        let declarationSpanHtml = $('.J-subscribe-declaration-span').html();
  
        let termsServiceHtml = `<a href="${termsServiceUrl}" target="_blank" class="text-#999 font-400 underline underline-offset-4">${termsService}</a>`;
        let privacyPolicyHtml = `<a href="${privacyPolicyUrl}" target="_blank" class="text-#999 font-400 underline underline-offset-4">${privacyPolicy}</a>`;
  
        declarationSpanHtml = declarationSpanHtml.replace('{termsService}', termsServiceHtml);
        declarationSpanHtml = declarationSpanHtml.replace('{PrivacyPolicy}', privacyPolicyHtml);
        $('.J-subscribe-declaration-span').html(declarationSpanHtml);
      }
    } catch (err) {

    }
  }
  // 捐赠跳转
  initFundingGrant() {
    try {
      document.querySelector('[data-photovolatic-funding-grant]').onclick = e => {
        // 数据埋码
        const { sectionTitle, buttonText, } = e.target.dataset
        this.GAEvent({
          position: sectionTitle,
          button_name: buttonText,
        })
      }
    } catch (err) {

    }
  }
  observe() {
    // 视频进入视口监听播放
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 进度条
          this.DOM.querySelectorAll('.balcony-progress').forEach((item, index) => {
            item.classList.add(`fill-${index + 1}`)
          })
          var styleSheet = document.styleSheets[0];
          styleSheet.insertRule('.glow-1::after { animation: fadeIn 1s ease-in-out 0s forwards; }', styleSheet.cssRules.length);

          // 文字 fade in
          this.DOM.querySelectorAll('[data-label-fade-in]').forEach(item => item.classList.add('label-fade-in'))
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.25, // 设置阈值为80%，即视频可见面积超过50%触发播放
    })

    Observer.observe(this.DOM)
  }

  // 数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"photovoltaics_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        "module": "Collect Information",
        ...params
      }
    });
  }
}